import { createSelector } from "../../../utils/createSelector.js";
var gridRowSpanningStateSelector = function(state) {
    return state.rowSpanning;
};
export var gridRowSpanningHiddenCellsSelector = createSelector(gridRowSpanningStateSelector, function(rowSpanning) {
    return rowSpanning.hiddenCells;
});
export var gridRowSpanningSpannedCellsSelector = createSelector(gridRowSpanningStateSelector, function(rowSpanning) {
    return rowSpanning.spannedCells;
});
export var gridRowSpanningHiddenCellsOriginMapSelector = createSelector(gridRowSpanningStateSelector, function(rowSpanning) {
    return rowSpanning.hiddenCellOriginMap;
});
